import * as React from 'react';
import Calendar from './calendar';
import * as moment from 'moment';

export interface DatePickerProps {
    value?: string;
    label?: string;
    disabled?: boolean;
    errors?: string[];
    format?: string;
    onChange?: (date: string) => void;
}

export interface DatePickerState {
    value: moment.Moment;
    show: boolean;
}

export default class DatePicker extends React.Component<DatePickerProps, DatePickerState> {
  constructor(props: DatePickerProps) {
    super(props);

    this.state = {
        value: moment(this.props.value || Date.now()),
        show: false
    }
  }


  public componentDidMount(){
    document.addEventListener('mousedown', this.handleClickOutside.bind(this));
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside.bind(this));
  }

  wrapperRef: any;

  handleClickOutside = (event) => {
       if (this.wrapperRef != undefined){
         if(event
           && !this.wrapperRef.contains(event.target) 
           && this.state.show) {
         this.toggleContent();
       }
     }
   }
   public toggleContent = () =>{
     this.setState({show: !this.state.show})
   }

  componentWillReceiveProps(nextProps: DatePickerProps){
      if(nextProps.value != this.props.value && nextProps.value){
          this.setState({value: moment(nextProps.value)})
      }
  }

  handleOpen = () => {
      
      this.setState({show: !this.state.show});
  }

  public render() {
    return (
      <div ref={e => this.wrapperRef = e} className={'date-picker ' + (this.props.disabled? 'disabled': '')}>
          <label className='label'>{this.props.label}</label>
          <div className='date-container'>
            <p className='date-value' onClick={() => {
                if(!this.props.disabled)
                    this.handleOpen();
            }
            }>
            {this.props.format? this.state.value.format(this.props.format): this.state.value.toString()}</p>
            { this.props.errors &&
              this.props.errors.map((item, index) => {
                  return <p key={'input-error' + index} className='input-error'>{item}</p>
              })
          }
            {this.state.show && <Calendar
                className='picker-calendar'
                value={this.state.value.toDate()}
                onChange={e => {
                    
                    var value = moment(e);

                    if(this.props.onChange)
                        if(this.props.format)
                            this.props.onChange(value.format(this.props.format));
                        else
                            this.props.onChange(value.toString())

                    this.setState({
                        show: false, value
                    })
                }}
            />}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/datepicker.tsx